import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../theme';
import {
  BaseButtonStyles,
  BaseButtonWrapperStyles,
  ButtonFocusStyles,
  StyledButtonProps,
} from './BaseButton';

type StyledButtonLinkProps = StyledButtonProps;

export type BaseButtonLinkProps = Partial<
  PropsWithChildren<StyledButtonLinkProps>
>;

export const BaseButtonLinkStyles = css<StyledButtonLinkProps>`
  ${BaseButtonStyles};
  text-decoration: none;

  ${({ size }) =>
    breakpointMap(
      size,
      (buttonSize) => `
        padding: ${theme.buttons.padding[buttonSize]};
        padding-top: 0;
        padding-bottom: 0;
      `
    )};
`;

export const BaseButtonLinkWrapper = styled.div<StyledButtonLinkProps>`
  ${BaseButtonWrapperStyles};

  &:active,
  &:focus,
  &:focus-within,
  &:focus-visible {
    ${ButtonFocusStyles};
  }

  a {
    ${BaseButtonLinkStyles};
  }
`;

export type ButtonLinkProps = BaseButtonLinkProps;

export const ButtonLink: React.FC<ButtonLinkProps> = ({
  fullWidth = false,
  size = 'medium',
  children,
}) => {
  return (
    <BaseButtonLinkWrapper fullWidth={fullWidth} size={size}>
      {children}
    </BaseButtonLinkWrapper>
  );
};
